{
  "de": {
    "courseEnrollments": {
      "headers": {
        "title": "Meine Fortbildungen"
      },
      "tabs": {
        "active": "Aktiv",
        "bookmarked": "Gemerkt",
        "completed": "Abgeschlossen"
      },
      "empty": {
        "noInProgress": "Du hast aktuell keine Fortbildungen in Arbeit.",
        "noBookmarked": "Du hast dir noch keine Fortbildungen gemerkt.",
        "noCompleted": "Du hast noch keine Fortbildungen abgeschlossen.",
        "showAllCourses": "Alle Fortbildungen im Fortbildungskatalog anzeigen"
      }
    }
  }
}
